import { render, staticRenderFns } from "./onboardingPackageContentDetails.vue?vue&type=template&id=75bfa4b8&"
import script from "./onboardingPackageContentDetails.vue?vue&type=script&lang=js&"
export * from "./onboardingPackageContentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports